export function fCurrency(x) {
  const val = Number(x);
  return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}
